import { useMutation } from "react-query";
import { apiResolver, useApi } from "@/api/useApi";

export type UploadQuackchatAssestResponse = {
  name: string;
  path: string;
};

export function useUploadQuackchatAssest(simulatorId?: string) {
  const { api } = useApi();

  return useMutation<UploadQuackchatAssestResponse, unknown, File>(
    async (file) => {
      let url = "/platform/quackchat-v2/upload-assest";
      if (simulatorId) {
        url += `?simulatorId=${simulatorId}`;
      }

      const formData = new FormData();
      formData.append("file", file);

      return apiResolver<UploadQuackchatAssestResponse>(
        api.post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
      );
    }
  );
}
